//#region Imports Packages and Libs

import { Component, Prop, Vue } from "vue-facing-decorator";
import NumberSpinner from "../../components/forms/number_spinner.vue";
import type { FormItemComponent } from "../../types/forms";

//#endregion

//#region Define the component in class-style

@Component({
	components: { NumberSpinner },
})
export default class FormItems extends Vue {
	//#region Class properties will be component data

	@Prop() components?: FormItemComponent[];
	@Prop() messageId?: string;

	//#endregion

	//#region Computed Properties

	get prefixClassName() {
		return this.$store.state.prefixClassName || "";
	}

	//#endregion

	//#region Main Methods

	//#endregion
}

//#endregion
